<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "product",
     fields: [
      {
        col:' col-12 col-md-12',
        key: "name",
        label: "Наименование",
        type: "field",
        textType: "text",
      },
        {
        key: "position",
        label: "Позиция",
        type: "field",
        textType: "number",
      },
      {
          col:' col-12 col-md-4 ',
          key: "image",
          label: "Логотип",
          type: "img",
      },
    ],
      /** APIs */
      removeLink: "",
      cardLink: "item_brand",
      itemLink: "warehouse/brands",
      setLink: "warehouse/brands",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
     
        {
          key: "name",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
